<template>
  <div class="container">
    <el-tabs v-model="activeTab">
      <el-tab-pane
        v-for="tab in tabs"
        :label="$t(tab.label)"
        :name="tab.name"
        :key="tab.name"
      >
        <component :is="tab.component" :model="model" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import EngagementContent from '@/modules/campaign-manage/components/analytics/EngagementContent.vue'
import PerformanceContent from '@/modules/campaign-manage/components/analytics/PerformanceContent.vue'
import ReportsContent from '@/modules/campaign-manage/components/analytics/ReportsContent.vue'
import { projectRoute } from '@/core/helpers'

export default {
  name: 'StepAnalytics',
  components: { PerformanceContent, EngagementContent },
  props: {
    model: {
      type: Object
    }
  },

  mounted() {
    this.activeTab = this.$route.query.tab || 'engagement'
  },

  data() {
    return {
      activeTab: 'engagement'
    }
  },

  computed: {
    tabs() {
      const tabs = [
        {
          name: 'engagement',
          label: 'CampaignAnalytics_Engagement_Tab',
          component: EngagementContent
        },
        {
          name: 'performance',
          label: 'CampaignAnalytics_Performance_Tab',
          component: PerformanceContent
        }
      ]

      if (this.$can('exportCampaignAnalytics')) {
        tabs.push({
          name: 'reports',
          label: 'CampaignAnalytics_Reports_Tab',
          component: ReportsContent
        })
      }

      return tabs
    },
    routeWithActiveTab() {
      return projectRoute({
        name: this.$route.name,
        query: { ...this.$route.query, ...{ tab: this.activeTab } },
        hash: '#analytics'
      })
    }
  },

  watch: {
    activeTab: {
      handler: function() {
        if (this.$route.query.tab !== this.activeTab) {
          this.$router.replace(this.routeWithActiveTab)
        }
      },
      deep: true
    }
  }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/pages/StepAnalytics.vue